import { useEffect } from "react";
import { useReconnect } from "wagmi";

const useEagerConnect = () => {
  const { reconnect } = useReconnect();

  useEffect(() => {
    const connectorId = window.localStorage.getItem("connectorId");
    if (connectorId) {
      reconnect();
    }
  }, []);
};

export default useEagerConnect;
